import Tablature from './Tablature';

export default Tablature;
